// Implementation taken from https://batmaid.myjetbrains.com/youtrack/agiles/95-0/99-220?issue=BAT-6541
// for PL: https://batmaid.myjetbrains.com/youtrack/issue/PWA-1315

import { DEFAULT_CLEANING_DURATION_MATRIX } from "@config/consts";

export default (
  bedrooms: number,
  bathrooms: number,
  durationMatrix?: number[][],
): number => {
  const matrix = durationMatrix || DEFAULT_CLEANING_DURATION_MATRIX;
  const MAX_DURATION = 10;
  const MAX_ROOMS = matrix.length;

  if (bedrooms >= MAX_ROOMS || bathrooms >= MAX_ROOMS) {
    return MAX_DURATION;
  }

  return matrix[bathrooms][bedrooms];
};

interface GetCleaningDurationData {
  min: number;
  max: number;
  durationMatrix: number[][];
  bedrooms: number;
  bathrooms: number;
}
export const getCleaningDuration = (data: GetCleaningDurationData): number => {
  let duration = data.durationMatrix[data.bathrooms][data.bedrooms];

  if (duration > data.max) {
    duration = data.max;
  }

  if (duration < data.min) {
    duration = data.min;
  }

  return duration;
};
